import { api } from "@/api";
import { QueryProps } from "@/types/Api";
import { MatchSuspensionsEditorResponse } from "@/types/ApiResponses/SportEvent";

export interface GetMatchesSuspensionsParams {
  feedType?: string;
  sportType?: string;
  lang?: string;
  targetUsername?: string;
  page?: number;
  pageSize?: number;
  // Server-side search (match id, team name or league name) — filters the
  // WHOLE cached set, not just the returned page (forwarded to
  // match-distributor as `search`).
  search?: string;
}

export const getMatchesSuspensions = async (
  props: QueryProps<GetMatchesSuspensionsParams>
): Promise<MatchSuspensionsEditorResponse> => {
  const res = await api.client.get(`/sport-events-new/suspensions`, {
    signal: props.signal,
    params: props.params,
  });
  return res.data;
};
